exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2KLIN-6JZHV85aTQ4RhVGx{padding:15px;display:flex;flex-flow:row wrap}._2KLIN-6JZHV85aTQ4RhVGx ._3qiNrfotV57i3j20sRUNFz{display:flex;align-items:baseline;width:auto;margin-bottom:0px}._2KLIN-6JZHV85aTQ4RhVGx ._3qiNrfotV57i3j20sRUNFz>div:first-child{margin-right:5px}.IOUC-QIp44XBcgP4CEV-c{display:inline-block}._2LJFPFHz86wDcAsY3thz1D{margin-bottom:20px}._1zCfbR4-rVRDvd20ev4HSy{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"inner": "_2KLIN-6JZHV85aTQ4RhVGx",
	"metric": "_3qiNrfotV57i3j20sRUNFz",
	"labelsUnder": "IOUC-QIp44XBcgP4CEV-c",
	"bottomMargin": "_2LJFPFHz86wDcAsY3thz1D",
	"link": "_1zCfbR4-rVRDvd20ev4HSy"
};